// packages/shared/theme/index.ts
export type Palette = {
  // 基礎
  background: string;
  gameBackground: string;
  surface: string;
  surfaceAlt: string;
  textPrimary: string;
  textSecondary: string;
  border: string;
  positive: string;   // Buy / 正向
  negative: string;   // Sell / 錯誤
  accent: string;     // 重點色（載入、強調）
  primary: string;    // 主要操作色
  muted: string;      // 次要、灰 / Guest 按鈕等
  paperBackground: string; // 紙張背景色
  paperBackgroundLight: string;
  popupBackground: string; // 彈出視窗背景色
  paperLineColor: string;
  tableTitleBackground: string; // 表格標題列背景色
  tableTitleTextColor: string;
  tableContentBackground: string; // 表格內容列背景色
  tableBorderColor: string;
  tableContentTextColor: string;
  inputColor: string;
  btnBackground: string;
  btnTextColor: string;
  selectedRowBackground: string; // 表格選取列背景色
  kChartBackground?: string; // K 線圖背景色

  // === 新增：品牌色 / UI 元件預設色 ===
  brand: {
    google: string;
    line: string;
  };
  ui: {
    buttonBorder: string;  // 統一按鈕邊框顏色
    overlay: string;       // Modal 遮罩顏色
    topBarBackground: string; // 頂部欄背景色
    topBarBorderBottom: string; // 頂部欄底線色
  }; 
  
};

export type AppTheme = {
  name: 'dark';
  isDark: boolean;
  colors: Palette;
  spacing: (n: number) => number;
  radius: { sm: number; md: number; lg: number };
  gameButtonBackground: string; // 遊戲按鈕背景色
  gameButtonDisabledBackground: string; // 遊戲按鈕禁用背景色
  logoutButtonBackground: string; // 登出按鈕背景色
  gameButtonFontSize: number;
  gameButtonTextColor: string;
  fontSize: number;
  fontColor: string;
  titleFontSize: number;  
  stockShopLotteryButtonColor: string;
  shopBuyButtonTextColor: string;
  shopBuyButtonColor: string;
  inputColor: string;
  inputBackgroundColor: string; 
  inputPlaceholderTextColor: string;
  paperFontColor: string;
  tableContentFontSize: number;
  tableTitleFontSize: number;
};

const common = {
  spacing: (n: number) => 4 * n,
  radius: { sm: 3, md: 6, lg: 10 },
  gameButtonBackground: '#4CAF50',
  gameButtonDisabledBackground: '#4CAF5050',
  logoutButtonBackground: '#DA2535',
  gameButtonFontSize: 24,
  gameButtonTextColor: '#f5f5f5',
  fontSize: 16,
  fontColor: '#f5f5f5',
  titleFontSize: 20,
  stockShopLotteryButtonColor: '#FFD700',
  shopBuyButtonTextColor: '#f5f5f5',
  shopBuyButtonColor: '#4CAF50',
  inputColor: '#333',
  inputBackgroundColor: '#eee',
  inputPlaceholderTextColor: '#333',
  paperFontColor: '#333',
};

export const darkTheme: AppTheme = {
  name: 'dark',
  isDark: true,
  tableTitleFontSize: 18,
  tableContentFontSize: 14,
  colors: {
    background: '#070E18',
    gameBackground: '#070E18',
    surface: '#15171C',
    surfaceAlt: '#1B1E24',
    textPrimary: '#E7E9ED',
    textSecondary: '#AEB4BF',
    border: '#2C313A',
    positive: '#42C77A',
    negative: '#FF6574',
    accent:   '#6C8DFF',
    primary:  '#7AA2F7',
    muted:    '#6B7280',
    paperBackground: '#0D3E51cc',
    paperBackgroundLight: '#eee',
    popupBackground: '#393939',
    paperLineColor: '#65f2fc',
    tableTitleBackground: '#65f2fc',
    tableTitleTextColor: '#1E1E1E',
    tableContentBackground: '#1E1E1E',
    tableBorderColor: '#6B7280',
    tableContentTextColor: '#65f2fc',    
    inputColor: '#aaa',
    btnBackground: '#238295',
    btnTextColor: '#65f2fc',
    selectedRowBackground: '#156A7A',
    kChartBackground: '#04111D',

    brand: {
      google: '#4285F4',
      line:   '#06C755',
    },
    ui: {
      buttonBorder: '#2C313A',
      overlay: 'rgba(0,0,0,0.45)',
      topBarBackground: '#333',
      topBarBorderBottom: '#555',
    },
  },
  ...common,
};
